import { useCallback } from "react";
import { useChosenDepartment } from "../contexts/ChosenDepartment";
import { useScheduleCacheEnabled } from "./useScheduleWeekRules";

/**
 * Where a person's own schedule opens from the staffing pages. With `staffing_schedule_cache` on, their profile, whose
 * weekly schedule loads their weeks itself; off, the employee-staffing page drawn from the old list, as before.
 */
export const useStaffSchedulePath = (): ((nurseId: number, isDraftMode: boolean) => string) => {
	const { chosenDepartment } = useChosenDepartment();
	const isCacheEnabled = useScheduleCacheEnabled();
	const departmentId = chosenDepartment.department_id;
	return useCallback(
		(nurseId: number, isDraftMode: boolean) =>
			isCacheEnabled ? `/${departmentId}/nurse/${nurseId}` : `/${departmentId}/employee-staffing/${nurseId}/${isDraftMode}`,
		[isCacheEnabled, departmentId],
	);
};
